
// import this.$swal from 'sweetalert'
// import store from '../store'
import router from "../../router";
export default router
